import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "./Layout";
import Home from "./Pages/Home";
import "bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/@fortawesome/fontawesome-free/css/all.css";
import AddTaskPage from "./Pages/AddTaskPage";
import CompletedTaskPage from "./Pages/CompletedTaskPage";
import PendingTaskPage from "./Pages/PendingTaskPage";
import AddCategoriesPage from "./Pages/AddCategoriesPage";
import EditTaskPage from "./Pages/EditTaskPage";
import TaskDetails from "./Pages/TaskDetails";
import Categories from "./Pages/Categories";
import ViewCategories from "./Pages/ViewCategories";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/AddTaskPage" element={<AddTaskPage />} />
          <Route path="/EditTaskPage" element={<EditTaskPage />} />
          <Route path="/completedTaskPage" element={<CompletedTaskPage />} />
          <Route path="/pendingTaskPage" element={<PendingTaskPage />} />
          <Route path="/addCategoriesPage" element={<AddCategoriesPage />} />
          <Route path="/Categories" element={<Categories />} />
          <Route path="/ViewCategories" element={<ViewCategories />} />
          <Route path="/taskDetails/:id" element={<TaskDetails />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
